import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import ObjectLinkBoxViewModelType from '@/ViewModels/Controls/ObjectLinkBoxViewModel';
import AssociationBoxType from '@/Controls/AssociationBox';

export default class ObjectLinkBox extends Control {

    private AssociationBox = ComponentManager.getControl<typeof AssociationBoxType>('AssociationBox');
    private jQueryControl: JQuery;
    private associationBox: AssociationBoxType;

    public constructor(private viewModel: ObjectLinkBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);
        
        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'objectlinkbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            focus: this.viewModel.isFocusable,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.associationBox != null) {
            this.associationBox = new this.AssociationBox(this.viewModel.associationBox);
            let tuple = this.associationBox.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('ObjectLinkBox', ObjectLinkBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');